import React, { useContext } from "react";
import PropTypes from "prop-types";
import { subscribe } from "venuescanner-js/react/helpers";
import SrpContainer from "../../containers/SrpContainer";
import FiltersContainer from "./FiltersContainer";
import { FilterContext } from "./context";
import classes from "./filterBar.module.scss";
import isDesktop from "../../helpers/isDesktop";

const MobileShowVenuesButton = subscribe({
  SrpContainer,
  FiltersContainer,
})(({ srpContainer, filtersContainer, then }) => {
  const { errors } = useContext(FilterContext);

  // if (!filtersContainer.hasFilters) return null

  return (
    <button
      type="button"
      className={classes.MobileShowVenuesButton}
      onClick={() => {
        srpContainer.patchQuery(filtersContainer.state.values);
        filtersContainer.reset();
        srpContainer.refresh({ replace: true });
        if (typeof then === "function") then();
      }}
      disabled={Object.values(errors).filter(Boolean).length > 0}
    >
      Show me the venues
    </button>
  );
});

MobileShowVenuesButton.propTypes = {
  then: PropTypes.func,
};

const DesktopClearFiltersButton = subscribe({
  SrpContainer,
  FiltersContainer,
})(
  ({ srpContainer: { clearFilters, hasFilters, refresh }, filtersContainer }) =>
    hasFilters && (
      <button
        type="button"
        className={classes.MobileShowVenuesButton}
        onClick={() => {
          clearFilters();
          filtersContainer.reset();
          refresh({ replace: true });
        }}
      >
        Clear filters
      </button>
    )
);

const ShowVenuesOrClearFiltersButton = (props) =>
  isDesktop() ? (
    <DesktopClearFiltersButton {...props} />
  ) : (
    <MobileShowVenuesButton {...props} />
  );

export default ShowVenuesOrClearFiltersButton;
